export const SET_TAB_MANAGEMENT = "SET_TAB_MANAGEMENT";
export const ACTIVATE_DESACTIVATE_ACCOUNT = "ACTIVATE_DESACTIVATE_ACCOUNT";
